"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chartisan = exports.ChartState = void 0;
var helpers_1 = require("./helpers");
var data_1 = require("./data");
var error_1 = require("./error");
var loader_1 = require("./loader");
/**
 * Represents the states of the chart.
 */
var ChartState;
(function (ChartState) {
    ChartState["Initializing"] = "initializing";
    ChartState["Loading"] = "loading";
    ChartState["Error"] = "error";
    ChartState["Show"] = "show";
    ChartState["Destroyed"] = "destroyed";
})(ChartState || (exports.ChartState = ChartState = {}));
/**
 * Chartisan class
 */
var Chartisan = /** @class */ (function () {
    // noinspection TypeScriptAbstractClassConstructorCanBeMadeProtected
    /**
   * Creates an instance of Chartisan.
   */
    function Chartisan(options) {
        /**
         * Stores the chartisan options. The options
         * assigned here are the defaults and can be
         * overwritten given the constructor options.
         */
        this.options = {
            el: '.chartisan',
            url: undefined,
            options: undefined,
            data: undefined,
            loader: {
                type: 'bar',
                size: [35, 35],
                color: '#000',
                text: 'Loading chart',
                textColor: '#a0aec0',
            },
            error: {
                type: 'general',
                size: [50, 50],
                color: '#f56565',
                text: 'There was an error',
                textColor: '#a0aec0',
                debug: true,
            },
            hooks: undefined,
        };
        /**
         * State of the chart.
         */
        this.cstate = ChartState.Initializing;
        var el = (this.options = __assign(__assign({}, this.options), options)).el;
        if (typeof el === 'string') {
            var element = document.querySelector(el);
            if (!element)
                throw Error("[Chartisan] Unable to find an element to bind the chart to a DOM element with the selector: '".concat(el, "'"));
            this.element = element;
        }
        else {
            this.element = el;
        }
        // Check to see if there's already a chart controller in the element.
        if (this.element.querySelector('.chartisan-controller')) {
            // There seems to be a chart already created there. We don't create a new chart since
            // we have no access to the chart instance that might be stored there. Overwriting the
            // existing chart will lead to a memory leak and a possible malfunction of the other instance.
            // The best we can do is to throw an error to indicate what's going on.
            throw Error("[Chartisan] There seems to be a chart already at the element selected by: '".concat(el, "'"));
        }
        this.controller = document.createElement('div');
        this.body = document.createElement('div');
        this.modal = document.createElement('div');
        this.bootstrap();
    }
    /**
     * Set he modal settings.
     */
    Chartisan.prototype.setModal = function (_a) {
        var _b = _a.show, show = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? '#FFFFFF' : _c, content = _a.content;
        this.modal.style.backgroundColor = color;
        this.modal.style.display = show ? 'flex' : 'none';
        if (content)
            this.modal.innerHTML = content;
    };
    /**
     * Changes the status of the chart.
     */
    Chartisan.prototype.changeTo = function (state, err) {
        switch (state) {
            case ChartState.Initializing:
            case ChartState.Loading: {
                // this.body.innerHTML = loader(this.options.loader!)
                this.setModal({
                    show: true,
                    content: (0, loader_1.loader)(this.options.loader),
                });
                break;
            }
            case ChartState.Show: {
                // this.body.innerHTML = ''
                this.setModal({ show: false });
                break;
            }
            case ChartState.Error: {
                this.setModal({
                    show: true,
                    content: (0, error_1.error)(this.options.error, err !== null && err !== void 0 ? err : new Error('Unknown Error')),
                });
                this.refreshEvent();
                break;
            }
        }
        this.cstate = state;
    };
    /**
     * Bootstraps the chart.
     */
    Chartisan.prototype.bootstrap = function () {
        // Append the controller and the modal
        // to the element.
        this.element.appendChild(this.controller);
        this.controller.appendChild(this.body);
        this.controller.appendChild(this.modal);
        // Append the classes to them.
        this.controller.classList.add('chartisan-controller');
        this.body.classList.add('chartisan-body');
        this.modal.classList.add('chartisan-modal');
        this.update(this.options);
    };
    /**
     * Requests the data to the server.
     */
    Chartisan.prototype.request = function (options) {
        var _this = this;
        if (!this.options.url)
            return this.onError(new Error('No URL provided to fetch the data.'));
        fetch(this.options.url, this.options.options)
            .then(function (res) { return res.json(); })
            .then(function (res) { return _this.onRawUpdate(res, options); })
            .catch(function (err) { return _this.onError(err); });
    };
    /**
     * Attaches the refresh event handler to the icon.
     */
    Chartisan.prototype.refreshEvent = function () {
        var _this = this;
        var refresh = this.controller.getElementsByClassName('chartisan-refresh-chart')[0];
        refresh.addEventListener('click', function () { return _this.update(); }, { once: true });
    };
    /**
     * Refresh the chart with new information.
     */
    Chartisan.prototype.update = function (options) {
        // Replace the configuration options.
        if (options === null || options === void 0 ? void 0 : options.url)
            this.options.url = options.url;
        if (options === null || options === void 0 ? void 0 : options.options)
            this.options.options = options.options;
        // Check to see if it's static data.
        if (options === null || options === void 0 ? void 0 : options.data) {
            // There's no need to request
            // new data from the server.
            var serverData = void 0;
            if (!(0, data_1.isServerData)(options.data)) {
                if (!(options === null || options === void 0 ? void 0 : options.background))
                    this.changeTo(ChartState.Loading);
                serverData = options.data();
            }
            else {
                serverData = options.data;
            }
            var data = this.getDataFrom(serverData);
            this.changeTo(ChartState.Show);
            return options.background
                ? this.onBackgroundUpdate(data, options === null || options === void 0 ? void 0 : options.additional)
                : this.onUpdate(data, options === null || options === void 0 ? void 0 : options.additional);
        }
        if (!(options === null || options === void 0 ? void 0 : options.background))
            this.changeTo(ChartState.Loading);
        this.request(options);
    };
    /**
     * Destroys the chart instance and removes
     * the controller node from the DOM.
     */
    Chartisan.prototype.destroy = function () {
        // Call the onDestroy method.
        this.onDestroy();
        // Remove the controller from the DOM.
        this.controller.remove();
        // Update the chart status.
        this.changeTo(ChartState.Destroyed);
    };
    /**
     * Gets the data from a given request, applying
     * the hooks of the chart.
     */
    Chartisan.prototype.getDataFrom = function (server) {
        var e_1, _a;
        var data = this.formatData(server);
        if (this.options.hooks) {
            try {
                for (var _b = __values(this.options.hooks.hooks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var hook = _c.value;
                    data = hook({ data: data, merge: helpers_1.mergeOptions, server: server });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return data;
    };
    /**
     * Called when the data is correctly received from
     * the server. This method calls onUpdate() internally.
     */
    Chartisan.prototype.onRawUpdate = function (response, options) {
        if (!(0, data_1.isServerData)(response))
            return this.onError(new Error('Invalid server data'));
        var data = this.getDataFrom(response);
        this.changeTo(ChartState.Show);
        if (options === null || options === void 0 ? void 0 : options.background) {
            this.onBackgroundUpdate(data, options === null || options === void 0 ? void 0 : options.additional);
        }
        else {
            this.onUpdate(data, options === null || options === void 0 ? void 0 : options.additional);
        }
    };
    /**
     * Handles an error when getting the data of the chart.
     */
    Chartisan.prototype.onError = function (err) {
        this.changeTo(ChartState.Error, err);
    };
    /**
     * Returns the current chart state.
     */
    Chartisan.prototype.state = function () {
        return this.cstate;
    };
    return Chartisan;
}());
exports.Chartisan = Chartisan;
